<template>
  <div class="list-load">
    <div class="content">
      <slot></slot>
    </div>
    <div class="bottom-btn" v-if="!disabled">
      <el-button
        class="load-btn"
        :class="btnClass"
        v-if="loadMoreStatus === 'suc' || loadMoreStatus === 'fail' || loadMoreStatus === 'loading'"
        :loading="loadMoreStatus === 'loading'"
        :outline="outline"
        @click="showMore"
      >{{$t('更多')}}</el-button>
      <p class="no-more" v-else-if="loadMoreStatus === 'nomore'">{{$t('FoodD_suspensionpage_In_the_zGEU')}}</p>
    </div>
  </div>
</template>
<script>
/**
 * 该组件是用来 作为列表壳子组件使用的
 * 有按钮加载、自动加载两种使用方式
 * 也可以禁用掉加载功能
 */
export default {
  name: 'List',
  props: {
    // 是否禁用加载
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    autoLoad: {
      type: Boolean,
      required: false,
      default: false,
    },
    // 待定  如果是自动加载模式：为触发加载的距离阈值，单位为px
    distance: {
      type: Number,
      required: false,
      default: 0,
    },
    // 加载状态 suc fail nomore loading
    loadMoreStatus: {
      type: String,
      required: false,
      default: 'loading',
    },
    outline: {
      type: Boolean,
      required: false,
      default: true,
    },
    btnClass: {
      type: String,
      required: false,
      default: '',
    }
  },
  data() {
    return {
      load: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.bindScroll();
    },
    showMore() {
      this.$emit('more');
    },
    bindScroll() {
      document.addEventListener('scroll', this.onScroll);
    },
    unbindScroll() {
      document.removeEventListener('scroll', this.onScroll);
    },
    onScroll(e) {
      if (this.disabled || !this.autoLoad) return;
      if (this.loadMoreStatus === 'loading' || this.loadMoreStatus === 'nomore')
        return;

      let scrollTop = document?.documentElement?.scrollTop || document?.body?.scrollTop;

      if (scrollTop <= 0) return;

      const el = this.$el;
      let scrollHeight = scrollTop + window?.innerHeight;
      let elementHeight = el?.offsetHeight;
      let reachBottom = elementHeight
          + el.getBoundingClientRect().top
          - document.body.getBoundingClientRect().top
          - scrollHeight
        <= this.distance;

      if (reachBottom) {
        this.showMore();
      }
    },
  },
  destroyed() {
    this.unbindScroll();
  },
};
</script>
<style lang="scss">
@media screen and (max-width: 768px){
  .load-btn.is-loading {
    width: rem(150);
  }
}
</style>
<style lang="scss" scoped src="./index.scss"></style>
